<div class="select-city">
  <div class="regions">
    <div class="region" *ngFor="let wallMaterial of wallMaterials" [ngClass]="wallMaterial.active ? 'active' : ''"
      (click)="changeActiveState(wallMaterial)">
      {{wallMaterial.title}}
    </div>
  </div>
  <div class="cities">
    <div class="cities_list" *ngFor="let types of wallMaterials">
      <ng-container *ngIf="types.active">
        <div *ngFor="let type of types.wall_material;  let i = index;">

          <div class="city" *ngIf="types.id !== 4">
            <label class="container-checkbox">{{type.title}}
              <input type="checkbox" [(ngModel)]="type.checked" (ngModelChange)="type.checked = $event"
                (change)="changedModel()">
              <span class="checkmark"></span>
            </label>
          </div>

          <div class="city" *ngIf="types.id == 4 && i < 2">
            <label class="container-checkbox">{{type.title}}
              <input type="checkbox" [(ngModel)]="type.checked" (ngModelChange)="type.checked = $event"
                (change)="changedModel()">
              <span class="checkmark"></span>
            </label>
          </div>

          <ng-container *ngIf="type.checked && type.id == 420">
            <div *ngFor="let type of types.wall_material;  let i = index;">
              <div class="city" *ngIf="i > 1">
                <label class="container-checkbox">{{type.title}}
                  <input type="checkbox" [(ngModel)]="type.checked" (ngModelChange)="type.checked = $event"
                    (change)="changedModel()">
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </ng-container>

        </div>
      </ng-container>
    </div>
    <div class="wall-materials">
      <ul class="list-wall-materials">
        <ng-container *ngFor="let types of wallMaterials">
          <ng-container *ngFor="let type of types.wall_material">
            <li *ngIf="type.checked">
              {{type.title}}
              <span class="item-close" (click)="closeSelectedMaterial(type)"></span>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
<div class="appartment-action">
  <div class="btn" [ngClass]="onchangeModel ? 'btn-apply' : 'btn-cancel'" (click)="onchangeModel ? saveState() : null">
    Подтвердить</div>
  <div class="btn btn-cancel" (click)="cancel()">Отменить</div>
</div>